// export const createReducer = (initialState, handlers) => {
//     return function reducer(state = initialState, action) {
//         if (handlers.hasOwnProperty(action.type)) {
//             return handlers[action.type](state, action);
//         } else {
//             return state;
//         }
//     };
// };

export const createActionCreator = (type, payload) => {
    return (...args) => ({
        payload: typeof payload === 'function' ? payload(...args) : payload,
        type: type,
    });
};

export * from './reduxUtil';
export * from './tools';
export * from './enums';
export { default as request } from './request';

export const sleep = val => {
    return new Promise(resovle => {
        setTimeout(resovle, val);
    });
};

export const paramsEncode = (param, key, encode) => {
    if (param === null) return '';
    let paramStr = '';
    let t = typeof param;
    if (t === 'string' || t === 'number') {
        if (param) {
            paramStr += '&' + key + '=' + (encode === null || !encode ? encodeURIComponent(param) : param);
        }
    } else if (t === 'boolean') {
        paramStr += '&' + key + '=' + (encode === null || !encode ? encodeURIComponent(param) : param);
    } else {
        for (let i in param) {
            let k = key === null || !key ? i : key + '[' + i + ']';
            paramStr += paramsEncode(param[i], k, encode);
        }
    }
    return paramStr;
};
export const arrParamsEncode = list => {
    let paramStr = '';
    for (let i = 0; i < list.length; i++) {
        let item = list[i];
        for (let j in item) {
            let key = j + '[' + i + ']';
            paramStr += '&' + key + '=' + encodeURIComponent(item[j]);
        }
    }
    return paramStr;
};

export const normalArrParamsEncode = list => {
    let paramStr = '';
    for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let key = 'list' + '[' + i + ']';
        paramStr += '&' + key + '=' + encodeURIComponent(item);
    }
    debugger
    console.log(paramStr);
    return paramStr;
};

export const dateConversion = function(format) {
    if (format) {
        if (format.length < 13) {
            format = format + '000';
        }
        let time = new Date(parseInt(format));
        let y = time.getFullYear();
        let m = time.getMonth() + 1 < 10 ? '0' + parseInt(time.getMonth() + 1) : time.getMonth() + 1;
        let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
        let h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
        let mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
        let s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
        // return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
        return y + '-' + m + '-' + d;
    }
};

export const timeConversion = function(time) {
    let timeArr = (time + '').split('');
    if (timeArr.length) {
        let startPos = timeArr.length == 3 ? 1 : 2;
        timeArr.splice(startPos, 0, ':');
        return timeArr.join('');
    } else {
        return '';
    }
};
export const stringToTime = function(str) {
    //console.log(str)
    if (str.toString()) {
        if (/\:/.test(str + '')) {
            return;
        }
        if (str == 0) {
            return '0:00';
        }
        let remainder = str.toString().length;
        switch (remainder) {
            case 1:
                str = '000' + str;
                break;
            case 2:
                str = '00' + str;
                break;
            case 3:
                str = '0' + str;
                break;
            default:
                str = str + '';
        }
        return str
            .match(/\d{2}/g)
            .join(':')
            .replace(/^0/, '');
    }
};
export const delayTimeToFinishTime = function(addMinute) {
   
    var nowDate = new Date();
    var date = new Date(nowDate.getTime() + addMinute*60*1000);

    var month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    var day = date.getDate();
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    var hour=date.getHours();
    var minute=date.getMinutes();
    var second=date.getSeconds();

    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
    }
    if (second >= 0 && second <= 9) {
        second = "0" + second;
    }
    var currentDateStr = date.getFullYear() +"-" + month +"-"+ day+" "+ hour + ":" + minute + ":" + second;
    return currentDateStr;
    
}

export const timeStampToStr = function(stamp) {
   
    
    var date = new Date(stamp);
    var month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    var day = date.getDate();
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    var hour=date.getHours();
    var minute=date.getMinutes();
    var second=date.getSeconds();

    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
    }
    if (second >= 0 && second <= 9) {
        second = "0" + second;
    }
    var currentDateStr = date.getFullYear() +"-" + month +"-"+ day+" "+ hour + ":" + minute + ":" + second;
    return currentDateStr;

}

export const getDate = function(datestr) {
    let temp = datestr.split('-');
    let date = new Date(temp[0], temp[1], temp[2]);
    return date;
};

export const getDateBetween = function(start, end) {
    let between = [];
    let startTime = getDate(start);
    let endTime = getDate(end);

    while (endTime.getTime() - startTime.getTime() >= 0) {
        console.log('startTime==', startTime, startTime.getMonth());
        let year = startTime.getFullYear();
        let month =
            startTime.getMonth().toString().length == 1 ? '0' + startTime.getMonth().toString() : startTime.getMonth();
        let day = startTime.getDate().toString().length == 1 ? '0' + startTime.getDate() : startTime.getDate();

        let date = year + '-' + month + '-' + day;
        between.push(date);

        startTime.setDate(startTime.getDate() + 1);
        console.log('startTime+1==', startTime.getDate(), startTime);
    }
    return between;
};

export const getDay = function(date) {
    let year = date.getFullYear();
    let month = date.getMonth();
    if (year % 4 == 0 && month == 2) {
        day = 29;
    } else if (year % 4 != 0 && month == 2) {
        day = 28;
    } else if (month == 4 || month == 6 || month == 9 || month == 11) {
        day = 30;
    } else {
        day = 31;
    }
    return day;
};
export const showDate = function(value) {
    return value.split('-')[2];
};

export const toThousands = function(num) {
    let result = '';
    let counter = 0;
    num = (num || 0).toString();
    for (let i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) {
            result = ',' + result;
        }
    }
    return result;
};



// WEBPACK FOOTER //
// ./utils/index.js